var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.4473 14C14.6273 10.4044 16.7866 8.26229 20 7.98178V5.99271C16.7866 5.7122 14.6273 3.59563 14.4473 0L12.0566 0.510018C12.1851 1.81056 12.6478 2.95811 13.419 4.00364C14.2159 5.02368 15.1157 5.6867 16.144 5.99271H0V7.98178H16.144C15.1157 8.2878 14.2159 8.95082 13.419 9.99636C12.6478 11.0419 12.1851 12.1894 12.0566 13.4645L14.4473 14Z","fill":"#FF757B"}));
}

Arrow.defaultProps = {"width":"20","height":"14","viewBox":"0 0 20 14","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
